export default "__VITE_ASSET__BHOLdRDH__"